/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path apihooks
 * @description Notification about MyTasks
 * @section 4.2.1.4
 */
import axios from "axios";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { useEffect } from "react";
import { useQuery, useQueryClient } from "react-query";
const useNotificationBell = (executeQuery: boolean = true) => {
  const qc = useQueryClient();
  const ctx = useAppContext();
  const { data, isLoading, refetch } = useQuery(
    ["notification-bell-my-tasks"],
    () => {
      return axios.get("/workflow/mytasks", {
        params: {
          modelId: ctx.fullModelId,
          include: "coming",
        },
      });
    },
    {
      enabled: executeQuery,
      cacheTime: 300 * 60 * 1000,
      staleTime: 300 * 60 * 1000,
    }
  );
  const hasNotification = executeQuery
    ? !isLoading && data?.data.data.length > 0
    : null;
  const refresh = () => {
    // Commented out on purpose - need to be considered if this is really needed. Causes heavy data fetching from server.
    // qc.invalidateQueries("notification-bell-my-tasks");
    // refetch();
  };
  useEffect(() => {
    if (ctx.fullModelId) {
      refresh();
    }
  }, [ctx.modelId]);
  return { hasNotification, refresh };
};
export default useNotificationBell;
